/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// React
import React, { useState, useEffect } from "react";

// Zaim engineering components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { useNavigate } from "react-router-dom";
import ConvertPiComponent from "../edits/ConvertToPI";

export default function buildQuotationTable(data, onEdit, onConvertPi) {
  const Client = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "Client", accessor: "client", width: "45%", align: "left" },
    { Header: "quoted By", accessor: "quotedBy", align: "center" },
    { Header: "grand total", accessor: "grandTotal", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    return {
      client: <Client name={item.customer.name} email={item.customer.email} />,
      quotedBy: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.user.name}
        </MDTypography>
      ),
      grandTotal: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          ₹{item.grandTotal}
        </MDTypography>
      ),
      action: (
        <>
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color="text"
            fontWeight="medium"
            onClick={(e) => {
              e.preventDefault();
              onEdit(item.id);
            }}
          >
            Edit
          </MDTypography>
          {/*<MDTypography*/}
          {/*  pl={2}*/}
          {/*  component="a"*/}
          {/*  href="#"*/}
          {/*  variant="caption"*/}
          {/*  color="text"*/}
          {/*  fontWeight="medium"*/}
          {/*  onClick={(e) => {*/}
          {/*    e.preventDefault();*/}
          {/*    onConvertPi(item.id);*/}
          {/*  }}*/}
          {/*>*/}
          {/*  Convert PI*/}
          {/*</MDTypography>*/}
          <ConvertPiComponent key={item.id} id={item.id} onConvertPi={onConvertPi} />
        </>
      ),
    };
  });

  return { columns, rows };
}
